class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

  function custCjkCartSw(button) {
  // Prevent any default behavior
  if (event) {
    event.preventDefault();
  }
  
  // Find the form that contains this button
  const form = button.closest('form');
  if (!form) {
    console.error('No form found for button:', button);
    return;
  }
  
  // Optional: Show loading state
  const originalText = button.textContent;
  console.log(originalText);
  //button.textContent = 'Adding...';
  button.disabled = true;
  
  // Get form data
  const formData = new FormData(form);
  
  // Add to cart via AJAX
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json'
    },
    body: formData
  })
  .then(response => {
    console.log('Add to cart response:', response.status, response.ok); // Debug log
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(cartItem => {
    console.log('Cart item added:', cartItem); // Debug log
    
    // Fetch updated page sections for the notification
    const sectionsToFetch = 'cart-notification-product,cart-notification-button,cart-icon-bubble';
    return fetch(`/?sections=${sectionsToFetch}`)
      .then(response => response.text())
      .then(html => {
        console.log('Sections HTML received'); // Debug log
        
        // Try different parsing strategies
        const sections = {};
        
        // Strategy 1: Try to parse as JSON first (some themes return JSON)
        try {
          const jsonData = JSON.parse(html);
          if (jsonData['cart-notification-product']) {
            sections['cart-notification-product'] = jsonData['cart-notification-product'];
            sections['cart-notification-button'] = jsonData['cart-notification-button'];
            sections['cart-icon-bubble'] = jsonData['cart-icon-bubble'];
          } else {
            throw new Error('Not JSON format');
          }
        } catch (e) {
          // Strategy 2: Parse as HTML and look for sections
          console.log('Parsing as HTML...'); // Debug log
          
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Log what sections are actually available
          const allSections = doc.querySelectorAll('[id*="shopify-section"]');
          console.log('Available sections:', Array.from(allSections).map(s => s.id));
          
          // Try multiple possible section selectors
          const sectionSelectors = [
            '#shopify-section-cart-notification-product',
            '#shopify-section-cart-notification',
            '[id*="cart-notification-product"]',
            '[id*="cart-notification"]'
          ];
          
          const buttonSelectors = [
            '#shopify-section-cart-notification-button',
            '#shopify-section-header',
            '[id*="cart-notification-button"]',
            '[id*="header"]'
          ];
          
          const bubbleSelectors = [
            '#shopify-section-cart-icon-bubble',
            '#shopify-section-header',
            '[id*="cart-icon-bubble"]',
            '[id*="header"]'
          ];
          
          // Find sections
          let productSection = null;
          for (const selector of sectionSelectors) {
            productSection = doc.querySelector(selector);
            if (productSection) break;
          }
          
          let buttonSection = null;
          for (const selector of buttonSelectors) {
            buttonSection = doc.querySelector(selector);
            if (buttonSection) break;
          }
          
          let bubbleSection = null;
          for (const selector of bubbleSelectors) {
            bubbleSection = doc.querySelector(selector);
            if (bubbleSection) break;
          }
          
          if (productSection) sections['cart-notification-product'] = productSection.innerHTML;
          if (buttonSection) sections['cart-notification-button'] = buttonSection.innerHTML;
          if (bubbleSection) sections['cart-icon-bubble'] = bubbleSection.innerHTML;
        }
        
        console.log('Parsed sections:', Object.keys(sections)); // Debug log
        
        // Show the cart notification
        const cartNotification = document.querySelector('cart-notification');
        if (cartNotification && Object.keys(sections).length > 0) {
          cartNotification.renderContents({
            key: cartItem.key,
            sections: sections
          });
        } else {
          console.error('Cart notification element not found or no sections parsed');
          // Fallback: Just show a simple alert or custom notification
          alert(`Added "${cartItem.product_title}" to cart!`);
        }
      });
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    alert('Error adding item to cart. Please try again.');
  })
  .finally(() => {
    // Reset button state
    //button.textContent = originalText;
    button.disabled = false;
  });
}



// Helper function to update cart count
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update various possible cart count elements
      const selectors = ['.cart-count', '.cart-count-bubble', '[data-cart-count]', '.header__icon--cart .visually-hidden'];
      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          el.textContent = cart.item_count;
        });
      });
    })
    .catch(error => console.log('Could not update cart count:', error));
}
